<template>
    <div class="widget webinar-widget">
        <header class="widget-header">
            <h3><i class="fal fa-chalkboard-teacher" /> Upcoming Training Webinar</h3>
        </header>
        <div class="widget-body">
            <div class="webinar-header">
                <div class="webinar-info">
                    <span class="date">
                        <i class="far fa-calendar" /> October 27th - 3pm Eastern (12pm Pacific)
                    </span>
                    <span class="duration">
                        <i class="far fa-clock" /> 45-60 mins
                    </span>
                </div>
                <h3>October Deep Dive: Podcast Monetization</h3>
                <div class="hosted-by">
                    <div class="host-avatar round-image">
                        <img src="/images/team/jonathan.jpg" alt="Nōn Wels">
                    </div>
                    <p>Hosted by <strong>Jonathan Hess</strong></p>
                </div>
            </div>
            <div class="webinar-description">
                <p>Join us on October 27th at 3pm Eastern (12pm Pacific) for our Deep Dive webinar series. We're talking about monetizing your podcast; what to expect, where to start, and common mistakes. Regardless of your experience level, this is a great opportunity to take your show to the next step and dip your toes into the world of making money from something you enjoy doing!</p>
            </div>
            <a
                v-if="user.pro"
                href="https://my.demio.com/ref/ZHzUorxvHcVcCKNr"
                class="btn"
                target="_blank"
            >Register Now</a>
            <a
                v-else
                href="#"
                class="btn is-green"
            >Upgrade to Pro and Register</a>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
    computed: mapState(['user']),

    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Opens upgrade modal
         *
         */
        openUpgradeModal() {
            this.changeUIState({ isUpgradeModalVisible: true });
        },
    },
};
</script>
